import createAxiosInstance from './createAxiosInstance'

const instance = createAxiosInstance(process.env.VUE_APP_MAPI_URL)

// Swagger: https://mapi-dev.kingnetsmart.com.tw/swagger/index.html#/Announcement
export const apiAnnouncement = {
  getLogs: (AnnouncementId) => instance.get(`/Announcement/${AnnouncementId}/Logs`),
  getReadRecord: (AnnouncementId) => instance.get(`/Announcement/${AnnouncementId}/ReadRecord`),
  updateFile: (formData) => instance.post('/Announcement/UpdateFile', formData)
}
